import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { getProxyUrl } from '../../utils/image';
import { getArenaBg } from '../../utils/matches';
import CountDown from './CountDown';
import { LEAGUES } from '../../constants/leagues';
import { useTicketConfig } from '../../hooks/ticket';

function MatchHeaderUpcoming({ match, homeTeamLogo, visitingTeamLogo }) {
  const {
    round,
    homeTeamName,
    visitingTeamName,
    arenaName,
    referees,
    homeTeamAbbrv,
    startDate,
  } = match;
  const referee = referees?.length > 0 ? referees[0] : 'EJ FASTSTÄLLT';
  const [ticketConfig] = useTicketConfig(homeTeamAbbrv);
  const arenabg =
    match?.configLeagueName !== LEAGUES.FUTSAL
      ? getProxyUrl(getArenaBg(homeTeamAbbrv), 1400, 788)
      : '/wp-content/themes/sef-leagues/images/match-hero.png';
  const niceDate = moment(startDate).format('ddd D MMM HH:mm');

  return (
    <div className="site-container site-container--hug-on-mobile">
      <section className="hero-image">
        <a className="hero-image__back" href="/matcher">
          <img
            src="/wp-content/themes/sef-leagues/images/arrow-back.svg"
            alt="Back"
          />
        </a>
        <div
          className="hero-image__container hero-image__container--match d-flex align-content-start align-items-lg-center"
          style={{ backgroundImage: `url(${arenabg})` }}
        >
          <div className="match-hero">
            <div className="match-hero__team">
              <img
                className="match-hero__team-logo"
                src={getProxyUrl(homeTeamLogo, 500, 500)}
                alt=""
              />
              <div className="match-hero__team-item align-items-center align-items-lg-start">
                <p className="match-hero__team-name heading-h6 heading-lg-h4 text-transform-none mb-2 text-center text-lg-left">
                  {homeTeamName}
                </p>
              </div>
            </div>
            <div className="match-hero__score match-hero__score--upcoming">
              <CountDown startDate={startDate} />
              {match?.configLeagueName !== LEAGUES.FUTSAL &&
                ticketConfig?.ticketUrl && (
                  <a
                    className="button button--primary-yellow button--large"
                    href={ticketConfig?.ticketUrl}
                  >
                    Köp biljetT
                  </a>
                )}
            </div>
            <div className="match-hero__team">
              <div className="match-hero__team-item align-items-center align-items-lg-end order-1 order-lg-0">
                <p className="match-hero__team-name heading-h6 heading-lg-h4 text-transform-none mb-2 text-center text-lg-left">
                  {visitingTeamName}
                </p>
              </div>
              <img
                className="match-hero__team-logo order-0 order-lg-1"
                src={getProxyUrl(visitingTeamLogo, 500, 500)}
                alt=""
              />
            </div>
            <div className="match-hero__info d-flex align-items-lg-center gap-3 gap-lg-5 justify-content-center mt-auto">
              <div className="d-flex flex-column flex-lg-row justify-content-start justify-content-lg-center align-items-center gap-2">
                <img
                  width="20"
                  src="/wp-content/themes/sef-leagues/images/calendar-logo.png"
                  alt="Date"
                />
                <p className="text-lg-small text-tiny text-uppercase text-center text-lg-start">
                  {niceDate}
                </p>
              </div>
              <div className="d-flex flex-column flex-lg-row justify-content-start justify-content-lg-center align-items-center gap-2">
                <img
                  width="20"
                  src="/wp-content/themes/sef-leagues/images/referee-logo.png"
                  alt="Referee"
                />
                <p className="text-lg-small text-tiny text-uppercase text-center text-lg-start">
                  {referee}
                </p>
              </div>
              <div className="d-flex flex-column flex-lg-row justify-content-start justify-content-lg-center align-items-center gap-2">
                <img
                  width="20"
                  src="/wp-content/themes/sef-leagues/images/arena-logo.png"
                  alt="Arena"
                />
                <p className="text-lg-small text-tiny text-uppercase text-center text-lg-start">
                  {arenaName}
                </p>
              </div>
              <div className="d-flex flex-column flex-lg-row justify-content-start justify-content-lg-center align-items-center gap-2">
                <img
                  width="20"
                  src={`/wp-content/themes/sef-leagues/images/${match?.configLeagueName}-icon.png`}
                  alt="League"
                />
                <p className="text-lg-small text-tiny text-uppercase text-center text-lg-start">
                  OMGÅNG {round}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

MatchHeaderUpcoming.propTypes = {
  match: PropTypes.shape({
    round: PropTypes.number.isRequired,
    homeTeamName: PropTypes.string.isRequired,
    visitingTeamName: PropTypes.string.isRequired,
    arenaName: PropTypes.string.isRequired,
    referees: PropTypes.arrayOf(PropTypes.string).isRequired,
    homeTeamAbbrv: PropTypes.string.isRequired,
    startDate: PropTypes.string.isRequired,
    configLeagueName: PropTypes.string.isRequired,
  }).isRequired,
  homeTeamLogo: PropTypes.string.isRequired,
  visitingTeamLogo: PropTypes.string.isRequired,
};

export default MatchHeaderUpcoming;
